import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BulkReassignService {
  constructor(private http: HttpClient) {}

  getComboData(postData): Observable<any> {
    return this.http.post(`/worklist/get-combo-list`, postData);
  }

  getAllMappedEmployees(grpId: any): Observable<any> {
    let postData = {
      wlGrpId: Number(grpId),
    };
    return this.http.post(`/admin/get-unit-grp-mpg`, postData);
  }

  reassignCase(postData: any): Observable<any> {
    return this.http.post(`/workflow/bulk-reassign-case`, postData);
  }

  getEmployeeList(params: HttpParams) {
    return this.http.get('/admin/employee-search-details', { params: params });
  }
}
